<template>
  <div>
    <div class="top">缴费详情</div>
    <div class="contaa">
      <div class="top1">
        <div class="title">{{ title }}</div>
      </div>

      <div class="top3" style="margin-top: 7px">
        <div class="toptitle" style="padding-top: 15px">
          <van-radio-group
            v-model="type"
            direction="horizontal"
            @change="changeradio"
          >
            <van-radio name="0" checked-color="#ee0a24" class="radiobox"
              >已支付</van-radio
            >
            <van-radio name="1" checked-color="#ee0a24" class="radiobox"
              >退款</van-radio
            >
            <van-radio name="2" checked-color="#ee0a24" class="radiobox"
              >未支付</van-radio
            >
          </van-radio-group>
        </div>
        <div class="toptitleaa">
          {{ type == 0 ? "已支付" : type == 1 ? "退款" : "未支付" }}学生<span
            class="zistyle"
            v-if="alldata"
            >({{ alldata ? alldata.length : "0" }})人</span
          >
          <span style="float: right"
            >总计：<span class="feey"
              >￥{{ (tjfee / 100).toFixed(2) }}</span
            ></span
          >
          <!-- <div class="van-multi-ellipsis--l2">
  >已支付列表为实缴金额，已支付有退款标记为<span style="orange">橘色</span>，
            退款列表为实际退款金额，标记为<span style="color:red;">红色</span>
</div> -->
          <div class="ondysa">已支付列表为<b>实收金额</b>，已支付有退款标记为<van-tag type="warning" plain>橘色</van-tag> <br />
            退款列表为<b>退款金额</b>，标记为<van-tag type="danger" plain>红色</van-tag></div>
        </div>
        <div v-if="alldata&&alldata.length > 0" class="onecont">
          <div class="student" v-for="(item, index) in onearr" :key="item.key">
            <van-collapse v-model="activeName" accordion>
              <van-collapse-item
                :title="`${item.key} (${item.items?item.items.length:0 })人`"
                :name="index + 1"
                :value="`合计：￥${(item.money / 100).toFixed(2)}`"
                v-if="type == 0"
              >               
                <template v-for="ele in item.items"   >                
                  <van-tag
                  plain    
                  :key="ele.item_id"              
                  :type="ele.refund_fee?'warning':'primary'"    
                  style="margin-right: 10px; line-height: 20px"
                  >{{ ele.item_name }} &nbsp;&nbsp;&nbsp; ￥{{
                    (ele.realPay_fee / 100).toFixed(2)
                  }}</van-tag
                >
                </template>
              </van-collapse-item>
              <van-collapse-item
              :title="`${item.key} (${item.items?item.items.length:0 })人`"
                :name="index + 1"
                :value="`合计：￥${(item.remoney / 100).toFixed(2)}`"
                v-if="type == 1"
              >
                <van-tag
                  plain
                  type="danger"
                  v-for="ele in item.items"
                  :key="ele.item_id"
                  style="margin-right: 10px; line-height: 20px"
                  >{{ ele.item_name }} &nbsp;&nbsp;&nbsp; ￥{{
                    (ele.refund_fee / 100).toFixed(2)
                  }}</van-tag
                >
              </van-collapse-item>
              <van-collapse-item
              :title="`${item.key} (${item.items?item.items.length:0 })人`"
                :name="index + 1"
                v-if="type == 2"
              >
                <van-tag
                  plain
                  type="primary"
                  v-for="ele in item.items"
                  :key="ele.item_id"
                  style="margin-right: 10px; line-height: 20px"
                  >{{ ele.item_name }}
                </van-tag>
              </van-collapse-item>
            </van-collapse>
            <!-- <div class="stop">
              <span>{{ item.nj_name }}{{ item.bj_name }}</span>
              <span v-if="item.fee"
                >已支付:<span class="feesure"
                  >￥{{ (item.fee / 100).toFixed(2) }}</span
                ></span
              >
            </div>
            <div class="scont">
              <span>{{ item.item_name }}</span>
              <span v-if="item.refund_fee" style="float: right"
                >退款:<span class="feey"
                  >￥{{ (item.refund_fee / 100).toFixed(2) }}</span
                ></span
              >
            </div> -->
          </div>
        </div>
        <div v-else class="onecont">
          <van-empty description="暂无数据" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 1,
      dataimfo: [],
      fee: "",
      datafee: [],
      creattime: "",
      title: "",
      nopay: [],
      type: "0",
      treedata: "",
      alldata: null,
      tjfee: 0,
      onearr: [],
    };
  },

  mounted() {
    this.title = this.$route.query.title;
    // this.getimfo();
     this.getdataimfo();
    // this.gettreedata();
  },

  methods: {
    getimfo() {
      // console.log(this.$route.query.id)
      let id = this.$route.query.id;
      this.fetchget(`/api/app/payment/${id}`, { id: id }).then((res) => {
        console.log(res, 111);
        if (res) {
          this.dataimfo = res.items;
          this.fee = res.summary.fee;
          // this.title = res.title;
          this.creattime =
            res.creationTime.split("T")[0] +
            " " +
            res.creationTime.split("T")[1].split(":")[0] +
            ":" +
            res.creationTime.split("T")[1].split(":")[1];
          this.datafee = res.details;
          this.nopay = res.noPaidStudents;
        }
      });
    },
    getdataimfo() {
      let data = {
        paymentId: this.$route.query.id,
        // orgid: this.treedata,
        MaxResultCount:10000,
        PayStatus: this.type,
      };
      this.fetchget("/api/report/StudentDetail", data).then((res) => {
        if (res.code < 0) {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        } else {
          this.alldata = res.data.items;
          if (this.type == 0) {
            this.tjfee += res.data.summary.realPay_fee;
          }
          if (this.type == 1) {
            this.tjfee += res.data.summary.refund_fee;
          }
          console.log(res.data.items,"aaa")
          this.onearr = this.handleGroup(res.data.items);
          let arr=[]
          
          this.onearr.forEach((item)=>{
            var money=0
            var remoney=0
            item.items.map((ele)=>{
              money+=ele.realPay_fee
              remoney+=ele.refund_fee
            })           
              arr.push({...item,money,remoney})
               console.log(money,arr)
          })
          this.onearr=arr
          console.log(this.onearr);
        }
      });
    },
    //数据格式化
    handleGroup(arr) {
      const obj = {};
      const groups = [];
      // var money=0
      arr.forEach((item) => {
        var key = item.nj_name+item.bj_name;
        // money += item.fee ;
        if (!obj[key]) {
          // 根据id分组
          groups.push({
            key: key,
            // bj_name: item.bj_name,
            // nj_name: item.nj_name,
            // money: money,
            items: [item],
          });
          obj[key] = item;
        } else {
          groups.find((v) => {
            // 选择符合条件的第一个元素
            if (v.key === key) {
              v.items.push(item);
              // v.money=money
            }
          });
        }
      });
      return groups;
    },
    //获取树
    gettreedata() {
      this.fetchget("/api/app/organizationUnit/manageOUTreeItem").then(
        (res) => {
          if (res.code > 0) {
            this.treedata = res.data[0].value;
            this.getdataimfo();
          } else {
            this.$notify({
              type: "danger",
              message: res.msg,
              color: "#ad0000",
              background: "#ffe1e1",
            });
          }
        }
      );
    },
    changeradio(value) {
      this.type = value;
      this.tjfee = 0;
      this.getdataimfo();
    },
  },
};
</script>

<style lang="scss" scoped>

.zistyle {
  color: #898989;
  font-weight: normal;
  font-size: 12;
  // float: right;
}
.contaa {
  // height:calc(100% - #{$--operation-height});
  overflow-y: auto;
}
.top {
  width: 375px;
  height: 44px;
  background-color: #dd0000;
  height: 44px;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
}
.top1 {
  width: 335px;
  // min-height: 30px;
  background-color: #ffffff;
  margin-bottom: 7px;
  padding: 10px 20px;
  .time {
    height: 20px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #90979d;
    margin-top: 10px;
  }
  .title {
    // min-height: 20px;
    font-family: MicrosoftYaHei;
    width: 335px;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #000000;
    word-wrap: break-word;
  }
}
.top2 {
  width: 345px;
  background-color: #ffffff;
  padding: 0 15px;
  margin-bottom: 7px;
  .toptitle {
    width: 345px;
    min-height: 40px;
    text-align: left;
    color: #434343;
    font-size: 15px;
    font-weight: 600;
    line-height: 40px;
  }
  .onedata {
    display: flex;
    justify-content: space-around;
    line-height: 40px;
    // min-height: 40px;
    .dataname {
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #000000;
    }
    .dataprice {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #dd0000;
    }
  }
  .heji {
    width: 345px;
    height: 60px;
    background-color: #ffffff;
    font-size: 15px;
    text-align: left;
    line-height: 60px;
    font-weight: 600;
    border-top: 1px solid #eee;
    .hejiprice {
      font-size: 24px;
      font-weight: 600;
      color: #dd0000;
    }
  }
  .xiangqing {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 0px;
    color: #90979d;
  }
}
.top3 {
  width: 375px;
 .toptitle {
    padding: 0 15px;
    width: 345px;
    // min-height: 40px;
    text-align: left;
    color: #434343;
    font-size: 15px;
    font-weight: 600;
    // line-height: 40px;
    margin-bottom: 7px;
    padding-bottom: 13px;
    background-color: #ffffff;
   
  }
  .toptitleaa {
    padding: 0 15px;
    width: 345px;
    min-height: 40px;
    text-align: left;
    color: #434343;
    font-size: 15px;
    font-weight: 600;
    line-height: 40px;
    margin-bottom: 7px;
    padding-bottom: 7px;
    background-color: #ffffff;
    .radiobox {
      line-height: 40px;
    }
     .ondysa{
       margin-top: 5px;
     width: 9.2rem;
    text-align: left;
    font-size: 0.37rem;
    color: #969799;
    line-height: 20px;
    font-weight: normal;
   
}
  }
  .onecont {
    max-height: 550px;
    overflow-y: scroll;
    background-color: #fff;
  }
  .onecont::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .student {
    padding: 0 15px;
    background-color: #ffffff;
    .nopay {
      font-size: 14px;
      line-height: 30px;
      padding: 0 10px;
      text-align: center;
    }
    .stop {
      font-size: 14px;
      line-height: 30px;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
    }

    .scont {
      font-size: 14px;
      line-height: 30px;
      padding: 0 10px;
      border-bottom: 1px solid #eeee;
    }
  }
}
.feey {
  color: #dd0000;
  font-size: 16px;
  font-weight: 600;
}
.feesure {
  color: #45e245;
  font-size: 16px;
  font-weight: 600;
}
</style>